import { styled } from "@mui/material";
import bulletLines from "../../../images/bulletLines.png";
import bizDevSchedule from "../../../images/bizdevScheduleImg.png";
import { internshipSchedule } from "./BizdevInternshipData";

const InternshipSchedule = () => {
  return (
    <Root>
      <Header>Your 6‑Week Journey</Header>
      <Content>
        <RowOne>
          <BulletImg src={bulletLines} />
          <ScheduleWrap>
            {internshipSchedule.map((i, _) => (
              <Schedule key={i.header}>
                <h4>{i.header}</h4>
                <p>{i.body}</p>
              </Schedule>
            ))}
          </ScheduleWrap>
        </RowOne>
        <RowTwo>
          <img src={bizDevSchedule} style={{ width: "100%" }} alt='An illustration of internship schedule' />
        </RowTwo>
      </Content>
    </Root>
  );
};

export default InternshipSchedule;

const Root = styled("div")(({ theme }) => ({
  color: "#fefefe",
  display: "flex",
  flexDirection: "column",
  gap: "80px",
  [theme.breakpoints.down(500)]: {
    gap: "40px",
  },
}));

const Header = styled("h2")(({ theme }) => ({
  textAlign: "center",
  width: "831px",
  margin: "auto",
  fontSize: "48px",
  lineHeight: 1.33,
  fontWeight: 700,
  [theme.breakpoints.down(900)]: {
    width: "100%",
    paddingInline: "20px",
    fontSize: "35px",
    lineHeight: 1.3,
  },
  [theme.breakpoints.down(500)]: {
    fontSize: "24px",
    lineHeight: "35px",
  },
}));

const Content = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "center",
  gap: "40px",
  [theme.breakpoints.down(900)]: {
    flexDirection: "column",
  },
}));

const RowOne = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "40px",
  position: "relative",
  width: "448px",
  alignItems: "center",
  paddingLeft: "20px",
  [theme.breakpoints.down(900)]: {
    width: "100%",
  },
}));

const RowTwo = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  gap: "40px",
}));

const BulletImg = styled("img")(({ theme }) => ({
  position: "absolute",
  left: 0,
  top: 51,
  [theme.breakpoints.down(900)]: {
    top: 10,
    height: "90%",
  },
}));

const ScheduleWrap = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "16px",
}));

const Schedule = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  gap: "6px",
  "&>h4": {
    fontSize: "18px",
    lineHeight: "30px",
    fontWeight: 700,
  },
  "&>p": {
    fontSize: "16px",
    lineHeight: "24px",
    fontWeight: 400,
    color: "#B7B7B7",
  },
}));
